'use client'
import { motion } from 'motion/react'
import { useSlate } from 'slate-react'
import { isMarkActive, toggleMark } from '../funcitons'
import React from 'react'

export function MarkButton({
  format,
  children,
  className,
}: {
  format: string
  children: React.ReactNode
  className?: string
}) {
  const editor = useSlate()
  const isActive = isMarkActive(editor, format)
  return (
    <motion.div whileTap={{ scale: 0.95 }}>
      <button
        type="button"
        onMouseDown={(event) => {
          event.preventDefault()
          toggleMark(editor, format)
        }}
        className={`toolbar-button ${isActive ? 'active' : ''} ${className ? ` ${className}` : ''}`}>
        {children}
      </button>
    </motion.div>
  )
}
